import React, { Component } from 'react'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import SimpleCard from './SimpleCard'
import RecipeReviewCard from './RecipeReviewCard'
import Button from '@material-ui/core/Button'

import PlayVerbs from './PlayVerbs'
import { SpeakText } from './SpeakVerbs'
//import { LoadSpeak } from './SpeakVerbs'

import Slide from '@material-ui/core/Slide'
import { bookmarVerb } from '../../store/actions/wordAction'

import IconButton from '@material-ui/core/IconButton'
import FavoriteIcon from '@material-ui/icons/Favorite'
import VerbsSwipeableTemporaryDrawer from './VerbsSwipeableTemporaryDrawer'
import { getFirestore } from 'redux-firestore'
import { getDefaultVoices } from '../shared/Voices'
import {
  changeLevels,
  fieldUpdate,
  changeDates,
} from '../../store/actions/wordAction'
import './VerbCard.scss'

export class VerbCard extends Component {
  state = {
    setting: [{ id: '3', voice1: '3', voice2: '3' }],
    settingSpeak: {
      Present: false,
      Past: true,
      Past1: false,
      Future: false,
      Conditional: false,
      Imperativ: false,
      Imperativ1: false,
      Verzug: 3,
      SpanishVoice: '',
      GermanVoice: '',
      EnglishVoice: '',
      FrenchVoice: '',
      ItalianVoice: '',
    },
    user_settings: {
      Right: 'Language2',
      Left: 'Language2',
      Up: 'Language1',
      Down: 'Language2',
      SpanishVoice: '',
      GermanVoice: '',
      EnglishVoice: '',
      FrenchVoice: '',
      ItalianVoice: '',
      X: 'Description1',
      Y: 'Description2',
      A: 'Description4',
      B: 'Description5',
      Start: 'Language1',
      Select: 'Language4',
    },
    sets: [{ id: '3', name: '3' }],
    //verbs:[{Language1:"",Language2:"",Present:[{}]}],
    verbs: [],
    original_verbs: [],
    mounted: false,
    currentWordId: 0,
    slide: false,
    language: 'All',
    verb_type: 'All',
    regular: 'All',
    frequency: 'All',
  }

  componentDidMount() {
    //window.speechSynthesis.onvoiceschanged = () => this.voicesload(this);
  }

  componentWillMount() {
    let firestore = getFirestore()
    var temp_settings = firestore
      .collection('user_settings')
      .doc(localStorage.getItem('user_id'))

    temp_settings
      .get()
      .then((doc) => {
        if (doc.exists) {
          //          console.log(doc.data());
          this.setState({
            user_settings: doc.data(),
          })
          console.log(this.state.settingSpeak)
        } else {
        }
      })
      .catch(function (error) {
        console.log('Error getting document:', error)
      })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.verbs != undefined && nextProps.verbs.length > 0) {
      this.setState({
        original_verbs: nextProps.verbs,
        //sets: nextProps.sets,
        verbs: nextProps.verbs,
        mounted: true,
        //    user_settings:nextProps.user_settings,
        slide: true,
      })
    }

    //mario
    // LoadSpeak();
  }

  changeCurrentID = (id) => {
    this.setState({
      currentWordId: id,
    })

    this.setState({
      slide: false,
    })
    let G_timer = setInterval(() => {
      this.setState({
        slide: true,
      })
      clearInterval(G_timer)
    }, 50)
  }

  handleSettingsChanged = (settings) => {
    this.setState({
      settingSpeak: settings,
    })
  }

  LetterClick = (letter) => {
    var filteredWords = this.state.original_verbs
    filteredWords = filteredWords.filter(function (word) {
      console.log(word)
      return word.Language1[0].toLowerCase() === letter.toLowerCase()
    })
    this.setState({
      verbs: filteredWords,
    })
  }

  handleCollectionLevelChange = (level) => {
    var filteredWords = this.state.original_verbs
    filteredWords = filteredWords.filter(function (word) {
      console.log(word)
      return word.level === level
    })
    this.setState({
      verbs: filteredWords,
    })
  }

  filterBySet_New = () => {
    // console.log(this.state.language);
    //  alert(this.state.frequency);
    let filteredWords = this.state.original_verbs
    if (this.state.language != 'All') {
      filteredWords = filteredWords.filter(
        (el) => el['set'] == this.state.language
      )
    }
    if (this.state.verb_type != 'All') {
      filteredWords = filteredWords.filter(
        (el) => el['verb_type'] == this.state.verb_type
      )
    }
    if (this.state.regular != 'All') {
      filteredWords = filteredWords.filter(
        (el) => el['regular'] == this.state.regular
      )
    }
    if (this.state.frequency != 'All') {
      filteredWords = filteredWords.filter(
        (el) => el['frequency'] == this.state.frequency
      )
    }
    this.setState({
      verbs: filteredWords,
    })
  }

  handleLanguageChange = (set) => {
    //STATE UPDATES ASNYHRONUS SO USE CALL BACK FUNCTION WHEN STATE UPDATES
    this.setState(
      {
        language: set,
      },
      this.filterBySet_New
    )
    //  this.filterBySet("set", "==", set, 50, "verbs");
    // this.filterBySet_New();
  }

  // handleSettingChange = (verb_type) => {
  //   this.setState(
  //     {
  //       verb_type: verb_type,
  //     },
  //     this.filterBySet_New
  //   );
  // };

  handleSettingChange = (name, value) => {
    //  alert(name + "  " + value);
    this.setState(
      {
        [name]: value,
      },
      this.filterBySet_New
    )
  }

  filterBySet(param1, equality, param2, limit, collection) {
    let single_document = {}
    const data = []
    let firestore = getFirestore()
    firestore
      .collection(collection)
      .where(param1, equality, param2)
      .limit(2)
      .get()
      .then((querySnapshot) => {
        //  firestore.collection("word_set").where("bookmarked","!=", true).orderBy("createdAt", "desc").limit(limit).get().then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          single_document = doc.data()
          single_document.id = doc.id
          data.push(single_document)
        })
        // data = data.sort((a, b) => a.createdAt > b.createdAt);
        this.setState({
          verbs: data,
        })
      })
  }

  handleBookmark = (booked) => {
    // alert(this.state.verbs[this.state.currentWordId].Language1);
    // alert(booked);
    this.props.bookmarVerb(
      this.state.verbs[this.state.currentWordId].id,
      booked
    )
  }

  handleBookmarkFilter = (onoff) => {
    // alert("redifilter");
    // const newTasks = this.state.OriginalTasks.filter(el => el[key].toLowerCase().indexOf(query.toLowerCase()) > -1);
    if (onoff) {
      //  const filteredWords = this.state.original_verbs.filter(
      const filteredWords = this.state.verbs.filter(
        (el) => el['bookmarked'] == true
      )
      this.setState({
        verbs: filteredWords,
      })
    } else {
      this.setState({
        verbs: this.state.original_verbs,
      })
    }
  }

  ClickEdit = () => {
    this.props.history.push('/editverb', {
      id: this.state.verbs[this.state.currentWordId].id,
    })
  }

  ClickDate = () => {
    var selected_items = []
    selected_items[0] = this.state.verbs[this.state.currentWordId].id

    this.props.changeDates(selected_items, 'verbs')
  }

  ClickLevel = () => {
    var level = this.state.verbs[this.state.currentWordId].level
    if (level == undefined) {
      level = 1
    }
    level += 1
    if (level > 7) {
      level = 1
    }
    var selected_items = []
    selected_items[0] = this.state.verbs[this.state.currentWordId].id
    this.props.changeLevels(selected_items, level, 'verbs')
    let temp = this.state.verbs
    temp[this.state.currentWordId].level = level
    this.setState({
      verbs: temp,
    })
  }

  UpdateField = (field_name, type) => {
    var selected_items = []
    selected_items[0] = this.state.verbs[this.state.currentWordId].id
    this.props.fieldUpdate(selected_items, type, 'verbs', field_name)
  }
  // UpdateRegular = (type) => {
  //   var selected_items = [];
  //   selected_items[0] = this.state.verbs[this.state.currentWordId].id;
  //   this.props.fieldUpdate(selected_items, type, "verbs", field_name);
  // };
  // UpdateFrequency = (type) => {
  //   var selected_items = [];
  //   selected_items[0] = this.state.verbs[this.state.currentWordId].id;
  //   this.props.fieldUpdate(selected_items, type, "verbs", field_name);
  // };

  render() {
    return (
      <div className="VerbCard margin1em">
        {/* <SimpleCard></SimpleCard> */}

        <Slide
          timeout="{ enter: 100, exit:0}"
          direction="right"
          in={this.state.slide}
        >
          <RecipeReviewCard
            handleBookmark={this.handleBookmark}
            handleSettingsChanged={this.handleSettingsChanged}
            settingSpeak={this.state.settingSpeak}
            verbs={this.state.verbs}
            selected={this.state.currentWordId}
            ClickEdit={this.ClickEdit}
            mounted={this.state.mounted}
            ClickLevel={this.ClickLevel}
            ClickDate={this.ClickDate}
            UpdateField={this.UpdateField}
            UpdateRegular={this.UpdateRegular}
            UpdateFrequency={this.UpdateFrequency}
          ></RecipeReviewCard>
        </Slide>

        <PlayVerbs
          settingSpeak={this.state.settingSpeak}
          user_settings={this.state.user_settings}
          verbs={this.state.verbs}
          changeCurrentID={this.changeCurrentID}
        ></PlayVerbs>

        <VerbsSwipeableTemporaryDrawer
          handleBookmarkFilter={this.handleBookmarkFilter}
          handleLanguageChange={this.handleLanguageChange}
          handleSettingChange={this.handleSettingChange}
          language={this.state.language}
          LetterClick={this.LetterClick}
          handleCollectionLevelChange={this.handleCollectionLevelChange}
          verb_type={this.state.verb_type}
          regular={this.state.regular}
          frequency={this.state.frequency}
        ></VerbsSwipeableTemporaryDrawer>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    bookmarVerb: (id, value) => dispatch(bookmarVerb(id, value)),
    changeLevels: (selected, value, collection) =>
      dispatch(changeLevels(selected, value, collection)),
    fieldUpdate: (selected, value, collection, field) =>
      dispatch(fieldUpdate(selected, value, collection, field)),
    changeDates: (selected, collection) =>
      dispatch(changeDates(selected, collection)),
  }
}

const mapStateToProps = (state) => {
  // console.log(state.firestore);

  return {
    settings: state.firestore.ordered.settings,
    user_settings: state.firestore.ordered.user_settings,
    // sets:  state.firestore.ordered.sets,
    verbs: state.firestore.ordered.verbs,
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect([
    {
      collection: 'verbs',
      orderBy: [['createdAt', 'desc']],
      // limit: 2,
    },
    // {
    //   collection: "settings"
    // },
    // {
    //   collection: "user_settings"
    // }
  ])
)(VerbCard)
